export function setQuery(query) {
    // NOTE: add migration here?
    return {
        type: ACTION_SET_QUERY,
        query,
    };
}
export const ACTION_SET_QUERY = 'QRY_ACTION_SET_QUERY';

/**
 * Changes the field ID on a sub condition
 * @param {int} conditionIndex AND index
 * @param {int} subConditionIndex OR index
 * @param {string} fieldId Field ID
 * @returns object
 */
export function replaceField(conditionIndex, subConditionIndex, fieldId) {
    return {
        type: ACTION_REPLACE_FIELD,
        conditionIndex,
        subConditionIndex,
        fieldId,
    };
}
export const ACTION_REPLACE_FIELD = 'REPLACE_FIELD';

/**
 * Adds a value to a sub condition
 * @param {int} conditionIndex AND index
 * @param {int} subConditionIndex OR index
 * @param {string} value Value to add
 * @returns object
 */
export function addValue(conditionIndex, subConditionIndex, value) {
    return {
        type: ACTION_ADD_VALUE,
        conditionIndex,
        subConditionIndex,
        value,
    };
}
export const ACTION_ADD_VALUE = 'ADD_VALUE';

/**
 * Changes a value in the query
 * @param {int} conditionIndex AND index
 * @param {int} subConditionIndex OR index
 * @param {int} valueIndex value index
 * @param {string} value New value
 * @returns object
 */
export function changeValue(conditionIndex, subConditionIndex, valueIndex, value) {
    return {
        type: ACTION_CHANGE_VALUE,
        conditionIndex,
        subConditionIndex,
        valueIndex,
        value,
    };
}
export const ACTION_CHANGE_VALUE = 'CHANGE_VALUE';

/**
 * Changes a sub condition operator
 * @param {int} conditionIndex AND index
 * @param {int} subConditionIndex OR index
 * @param {string} operatorId Operator ID
 * @returns object
 */
export function changeOperator(conditionIndex, subConditionIndex, operatorId) {
    return {
        type: ACTION_CHANGE_OPERATOR,
        conditionIndex,
        subConditionIndex,
        operatorId,
    };
}
export const ACTION_CHANGE_OPERATOR = 'CHANGE_OPERATOR';

/**
 * Adds a sub condition
 * @param {int} conditionIndex AND index
 * @param {object} condition
 * @param {string} condition.field          Field name
 * @param {string} condition.operator       Operator ID
 * @param {array}  condition.values         List of values (optional)
 * @returns object
 */
export function addSubCondition(conditionIndex, {field, operator, values = []}={}) {
    return {
        type: ACTION_ADD_SUB_CONDITION,
        conditionIndex,
        field,
        operator,
        values,
    };
}
export const ACTION_ADD_SUB_CONDITION = 'ADD_SUB_CONDITION';

/**
 * Removes a sub condition
 * @param {*} conditionIndex
 * @param {*} subConditionIndex
 * @returns object
 */
export function removeSubCondition(conditionIndex, subConditionIndex) {
    return {
        type: ACTION_REMOVE_SUB_CONDITION,
        conditionIndex,
        subConditionIndex,
    };
}
export const ACTION_REMOVE_SUB_CONDITION = 'REMOVE_SUB_CONDITION';

/**
 * Adds a new contition
 * @param {string} categoryId Category ID
 * @returns object
 */
export function addCondition(categoryId) {
    return {
        type: ACTION_ADD_CONDITION,
        categoryId,
    };
}
export const ACTION_ADD_CONDITION = 'ADD_CONDITION';

/**
 * Removes a condition
 * @param {int} conditionIndex AND index
 * @returns object
 */
export function removeCondition(conditionIndex) {
    return {
        type: ACTION_REMOVE_CONDITION,
        conditionIndex,
    };
}
export const ACTION_REMOVE_CONDITION = 'REMOVE_CONDITION';
